<template>
    <div>
        <navTitle title="IM Club"/>
        <div v-if="page_init" class="con">
            <!--<div class="tip_title" v-if="!club_user||is_expired">🚫Belum ada undangan klub yang diterima</div>&lt;!&ndash;暂未收到俱乐部邀请&ndash;&gt;
            <div v-else>-->
            <div>
                <div class="tip_title" v-if="is_open">⚠️The event hasn't started yet</div><!--活动暂未开启-->
                <div class="club-open" v-else>
                    <div class="code-area" v-if="is_activation===0||is_expired">
                        <div class="points">
                            <lable>🌟</lable>
                            <lable class="points-det">{{club_points_info['current_points']}}/{{club_points_info['accumulated_points']}}</lable>
                            <div><b class="jh" @click="showGoods()">Redeem prizes</b></div>
                        </div>
                        <mt-popup class="popup-visible" v-model="goods_list">
                            <div class="product-popup-content">
                                <div class="product">
                                    <div class="goods-img">{{club_exchange_arr[1]}} day club qualification</div>
                                    <div class="product-info">
                                        <!--                                            <div class="product-name">Product 1</div>-->
                                        <div class="product-price" @click="pointsExchange()">{{club_exchange_arr[0]}}🌟</div>
                                    </div>
                                </div>
                            </div>
                        </mt-popup>
                        <div class="invite-introduction">
                            <p>Enter the invitation code sent by the club boss to become a club member</p>
                            <!--输入俱乐部Boss发送的邀请码，成为俱乐部成员-->
                            <p>This club has various additional benefits</p><!--俱乐部有各种额外福利-->
                            <p><b>There will be a time limit after becoming a club member, during this period please
                                take advantage of the useful time</b></p><!--成为俱乐部成员后会有时间期限，在此期间请把握住福利时间-->
                            <p>When your club membership time has expired, you can become a member of the club again if
                                You receive an invitation code.</p><!--当俱乐部成员时间到期，若收到邀请码可再次成员俱乐部会员-->
                        </div>
                        <mt-field class="input-code" label="Code" placeholder="Invitation code" v-model="code">
                            <Button class="receive-btn" type="primary" size="small" @click="confirmJoin()">
                                Confirm
                            </Button>
                        </mt-field>
                    </div>
                    <div v-else>
                        <div class="club-points">
                            <lable class="club-points-icon">🌟</lable>
                            <lable class="club-points-det">{{club_points_info['current_points']}}/{{club_points_info['accumulated_points']}} </lable>
                            <b @click="showPopupClub">
                                <svg t="1700462139458" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10202" width="32" height="32"><path d="M0 0h1024v1024H0z" fill="#FFFFFF" fill-opacity="0" p-id="10203"></path><path d="M510.045 0C228.352 0 0 228.352 0 510.045c0 281.67 228.352 509.999 510.045 509.999 281.67 0 510.022-228.352 510.022-510.022C1020.067 228.352 791.738 0 510.045 0z m0 792.972a56.576 56.576 0 1 1 0-113.176 56.576 56.576 0 0 1 0 113.176z m28.276-229.4c0 31.349-12.986 56.576-28.276 56.576s-28.3-25.227-28.3-56.576l-28.3-251.578a56.576 56.576 0 0 1 113.176 0l-28.3 251.578z" fill="#F7A200" p-id="10204"></path></svg>
                            </b>
                        </div>
                        <mt-popup class="popup-visible" v-model="popupVisible">
                            <div class="popup-content">
                                <div>Club star rating: Available stars/total stars</div>
                                <p>Complete tasks to accumulate stars</p>
                                <p>Stars can be redeemed for prizes or club time</p>
                                <p>Total stars are also a symbol of status. When you accumulate a certain number of stars, you can enjoy the benefits of the corresponding level</p>
                            </div>
                        </mt-popup>
                        <div class="expire_date-tip">{{expire_title}} <b class="expire_date">{{expire_date}}</b></div>
                        <div class="club-sign">
                            <div class="sign-content">Log in today to get it
                                {{sign_type===0?'integral':'Amount'}} {{sign_num}}
                            </div><!--今日签到可以获取积分/金额-->
                            <div class="sign-btn">
                                <Button v-if="!sign_info" class="receive-btn" type="primary" size="large"
                                        @click="sign()">
                                    <img src="../../assets/images/sign.png" height="20" width="20" slot="icon">
                                    Sign<!--签到-->
                                </Button>
                                <Button v-else class="receive-btn" type="primary" size="large" disabled>
                                    <img src="../../assets/images/signed.png" height="20" width="20" slot="icon">
                                    Signed
                                </Button>
                            </div>
                        </div>
                        <div class="award-title">Top up awards({{today_date}})</div><!--充值奖励-->
                        <div class="progress-container" v-for="v in club_recharge_award_arr">
                            <div class="left">
                                <div class="progress-title">Done to get ₱{{v[1]}} & 🌟{{v[2]}}</div>
                                <!--完成任务可获得Rp-->
                                <progress :value="Math.ceil((parseInt(today_recharge_count) / parseInt(v[0])) * 100)"
                                          max="100" style="width: 100%"/>
                                <div class="progress-amount">
                                    {{today_recharge_count>v[0]?v[0]:today_recharge_count}}/{{v[0]}}
                                </div>
                            </div>
                            <div class="right">
                                <Button v-if="v[3]===0" class="receive-btn" type="primary" size="small"
                                        @click="clubAward(v[0],v[1],v[2],1)">Receive<!--领取-->
                                </Button>
                                <Button v-else class="receive-btn" type="primary" size="small" disabled>Received
                                    <!--已领取-->
                                </Button>
                            </div>
                        </div>
                        <div class="award-title">Withdrawal awards({{today_date}})</div><!--提现奖励-->
                        <div class="progress-container" v-for="v in club_withdraw_award_arr">
                            <div class="left">
                                <div class="progress-title">Done to get ₱{{v[1]}} & 🌟{{v[2]}}</div>
                                <progress :value="Math.ceil((parseInt(today_withdraw_count) / parseInt(v[0])) * 100)"
                                          max="100" style="width: 100%"/>
                                <div class="progress-amount">
                                    {{today_withdraw_count>=v[0]?v[0]:today_withdraw_count}}/{{v[0]}}
                                </div>
                            </div>
                            <div class="right">
                                <Button v-if="v[3]===0" class="receive-btn" type="primary" size="small"
                                        @click="clubAward(v[0],v[1],v[2],2)">Receive
                                </Button>
                                <Button v-else class="receive-btn" type="primary" size="small" disabled>Received
                                </Button>
                            </div>
                        </div>
                        <div class="award-title">Consumption Awards({{today_date}})</div><!--流水奖励-->
                        <div class="progress-container" v-for="v in club_order_award">
                            <div class="left">
                                <div class="progress-title">Done to get ₱{{v[1]}} & 🌟{{v[2]}}</div>
                                <progress :value="Math.ceil((parseInt(order_num) / parseInt(v[0])) * 100)"
                                          max="100" style="width: 100%"/>
                                <div class="progress-amount">
                                    {{order_num>=v[0]?v[0]:order_num}}/{{v[0]}}
                                </div>
                            </div>
                            <div class="right">
                                <Button v-if="v[3]===0" class="receive-btn" type="primary" size="small"
                                        @click="clubAward(v[0],v[1],v[2],3)">Receive
                                </Button>
                                <Button v-else class="receive-btn" type="primary" size="small" disabled>Received
                                </Button>
                            </div>
                        </div>
                       <!-- <div class="progress-container">
                            <div class="left">
                                <div class="progress-title">Done to get ₱{{club_order_award[0][1]}}
                                </div>
                                <progress
                                        :value="Math.ceil((parseInt(order_num) / parseInt(club_order_award[0][0])) * 100)"
                                        max="100" style="width: 100%"/>
                                <div class="progress-amount">
                                    {{order_num>club_order_award[0][0]?club_order_award[0][0]:order_num}}/{{club_order_award[0][0]}}
                                </div>
                            </div>
                            <div class="right">
                                <Button v-if="club_order_award[0][2]===0" class="receive-btn" type="primary"
                                        size="small"
                                        @click="clubAward(club_order_award[0][0],club_order_award[0][1],3)">Receive
                                </Button>
                                <Button v-else class="receive-btn" type="primary" size="small" disabled>Received
                                </Button>
                            </div>
                        </div>-->
                        <div class="award-title">Commission Awards({{activation_time}}~{{expire_date}})</div>
                        <!--佣金奖励-->
                        <div class="progress-container" v-for="v in club_commission_award_arr">
                            <div class="left">
                                <div class="progress-title">Done to get ₱{{v[1]}} & 🌟{{v[2]}}</div>
                                <progress :value="Math.ceil((parseInt(brokerage_price) / parseInt(v[0])) * 100)"
                                          max="100" style="width: 100%"/>
                                <div class="progress-amount">
                                    {{brokerage_price>=v[0]?v[0]:brokerage_price}}/{{v[0]}}
                                </div>
                            </div>
                            <div class="right">
                                <Button v-if="v[3]===0" class="receive-btn" type="primary" size="small"
                                        @click="clubAward(v[0],v[1],v[2],4)">Receive
                                </Button>
                                <Button v-else class="receive-btn" type="primary" size="small" disabled>Received
                                </Button>
                            </div>
                        </div>
                        <div class="buttom-con"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import navTitle from "../../components/navTitle"
    import {Button, Field,Popup} from 'mint-ui'
    import 'mint-ui/lib/style.css'
    import {
        getClubAwardInfo,
        joinClub,
        clubUserSign,
        getRechargeAward,
        getWithdrawAward,
        getOrderAward,
        getCommissionAward,
        clubPointsExchange
    } from "../../api/activity"
    import {DebounceBy} from "../../api/user"

    export default {
        name: "Club",
        components: {
            navTitle,
            Button,
            'mt-field': Field,
            'mt-popup': Popup
        },
        data() {
            return {
                page_init: false,
                club_user: false,
                is_expired: false,
                sign_info: false,
                is_open: false,
                popupVisible: false,
                goods_list: false,
                is_activation: 0,
                code: '',
                sign_type: 0,
                sign_num: 0,
                club_recharge_award_arr: [],
                club_withdraw_award_arr: [],
                club_commission_award_arr: [],
                club_order_award: [],
                today_recharge_count: 0,
                today_withdraw_count: 0,
                brokerage_price: 0,
                order_num: 0,
                today_date: '',
                activation_time: '',
                expire_date: '',
                expire_title: '',
                club_points_info: '',
                club_exchange_arr: [0,0]
            }
        },
        mounted: function () {
            this.getClubInfo()
        },
        methods: {
            showGoods(){
                this.goods_list = !this.goods_list
            },
            showPopupClub(){
                // console.log(222)
                this.popupVisible = !this.popupVisible
            },
            getClubInfo() {
                let that = this
                getClubAwardInfo().then(res => {
                    that.page_init = true
                    that.club_user = res.data.club_info === null ? false : true
                    that.sign_info = res.data.sign_info === null ? false : true
                    that.is_expired = res.data.is_expired
                    that.is_activation = res.data.club_info.is_activation
                    that.is_open = res.data.is_open === 1 ? false : true
                    that.sign_type = res.data.club_sign_award_type
                    that.sign_num = res.data.club_sign_award_num
                    that.club_recharge_award_arr = res.data.club_recharge_award_arr
                    that.club_withdraw_award_arr = res.data.club_withdraw_award_arr
                    that.club_commission_award_arr = res.data.club_commission_award_arr
                    that.club_order_award = res.data.club_order_award
                    that.today_recharge_count = res.data.today_recharge_count
                    that.today_withdraw_count = res.data.today_withdraw_count
                    that.order_num = res.data.order_num
                    that.today_date = res.data.today_date
                    that.expire_date = res.data.expire_date
                    that.expire_title = res.data.expire_title
                    that.activation_time = res.data.activation_time
                    that.brokerage_price = res.data.brokerage_price
                    that.club_points_info = res.data.club_points_info
                    that.club_exchange_arr = res.data.club_exchange_arr
                    // console.log(res)
                })
            },
            // 活跃度兑换
            pointsExchange:DebounceBy(function () {
                this.goods_list = !this.goods_list
                let that = this
                this.$dialog.confirm({
                    mes: 'Confirmation of exchange?',
                    title: 'Redemption Tips',
                    opts: [
                        {
                            txt: 'Cancel',
                            color: false,
                            callback: () => {
                                return this.$dialog.toast({mes: 'Canceled'});
                            }
                        },
                        {
                            txt: 'Confirm',
                            color: "#00C3F9",
                            callback: () => {
                                that.$dialog.loading.open('loading...')
                                clubPointsExchange().then(res => {
                                    // console.log(res)
                                    that.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg})
                                    that.goods_list = !that.goods_list
                                    that.getClubInfo()
                                }).catch(res => {
                                    // console.log(res)
                                    that.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg});
                                });
                            }
                        }
                    ]
                });
            },3000),
            // 加入俱乐部
            confirmJoin: DebounceBy(function () {
                if (this.code === '')
                    return this.$dialog.toast({mes: 'Please enter the invitation code'})
                let that = this
                joinClub({code: that.code}).then(res => {
                    if (res.status === 200) {
                        that.$dialog.toast({mes: res.msg})
                        that.getClubInfo()
                    }
                }).catch(err => {
                    return that.$dialog.toast({mes: err.msg})
                })
            }, 2000),
            // 签到
            sign: DebounceBy(function () {
                let that = this
                clubUserSign().then(res => {
                    if (res.status === 200) {
                        that.$dialog.toast({mes: res.msg})
                        that.getClubInfo()
                    }
                }).catch(err => {
                    return that.$dialog.toast({mes: err.msg})
                })
            }, 2000),
            clubAward: DebounceBy(function (num, amount,points, type) {
                let that = this
                let param = {num: num, amount: amount,points: points}
                if (type === 1) {
                    getRechargeAward(param).then(res => {
                        if (res.status === 200) {
                            that.$dialog.toast({mes: res.msg})
                            that.getClubInfo()
                        }
                    }).catch(err => {
                        return that.$dialog.toast({mes: err.msg})
                    })
                } else if (type === 2) {
                    getWithdrawAward(param).then(res => {
                        if (res.status === 200) {
                            that.$dialog.toast({mes: res.msg})
                            that.getClubInfo()
                        }
                    }).catch(err => {
                        return that.$dialog.toast({mes: err.msg})
                    })
                } else if (type === 3) {
                    getOrderAward(param).then(res => {
                        if (res.status === 200) {
                            that.$dialog.toast({mes: res.msg})
                            that.getClubInfo()
                        }
                    }).catch(err => {
                        return that.$dialog.toast({mes: err.msg})
                    })
                } else {
                    getCommissionAward(param).then(res => {
                        if (res.status === 200) {
                            that.$dialog.toast({mes: res.msg})
                            that.getClubInfo()
                        }
                    }).catch(err => {
                        return that.$dialog.toast({mes: err.msg})
                    })
                }
            }, 2000)
        }
    }
</script>

<style scoped>
    .con {
        margin-top: 1rem;
        background: #59316b;
        /*background: #4B0082;*/
        padding-bottom: 10px;
        margin-bottom: 50px;
    }

    .tip_title {
        text-align: center;
        padding: 15px 3px;
        color: darkgrey;
        font-size: .35rem;
    }

    .points{
        width: 100%;
        position: relative;
        font-size: 50px;
        text-align: center;
        margin-top: 50px;
    }
    .points-det{
        color: #fff;
        font-weight: bold;
    }

    .jh{
        font-size: 16px;
        color: #00c3f9;
    }

    .club-open {
        width: 100%;
        height: 1500px;
        background-image: url("../../assets/images/bg.png");
        background-size: contain;
        /*background-repeat: no-repeat;*/
        /*background-position: center;*/
        background-repeat: repeat-x;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }

    .code-area {
        width: 100%;
        position: absolute;
    }

    .invite-introduction {
        position: relative;
        background-color: rgba(0, 0, 0, 0.3);
        text-align: left;
        width: 96%;
        margin-left: 2%;
        margin-top: 80px;
        padding: 10px 20px;
        border-radius: 5px;
        color: #fff;
        font-size: .24rem;
        line-height: .4rem;
    }

    p::before {
        content: "●";
        margin-right: 5px; /* 可选：为了添加一些间距 */
    }

    .input-code {
        position: relative;
        border: 1px solid #eee;
        margin: 110px 15px;
    }

    .club-sign {
        width: 100%;
        padding: 45px 10px 10px 10px;
    }

    .sign-content {
        background-color: rgba(248, 248, 255, 0.4);
        color: #fff;
        padding: 10px 20px;
        /*border-radius: 5px;*/
        margin-top: 5px;
        font-size: .24rem;
    }

    .sign-btn {
        margin-top: 10px;
        padding: 3px 15px;
    }

    .club-points-icon{
        font-size: 20px;
    }

    .club-points{
        position: absolute;
        right: 0;
        color: #fff;
        padding-right: 5px;
        padding-top: 3px;
        z-index: 99;
    }

    .popup-visible{
        border-radius: 3px;
    }

    .popup-content{
        width: 350px;
        padding: 5px;
        font-size: 12px;
        color: #2F4F4F;
    }

    @keyframes breathe {
        0% {
            font-size: 14px;
        }
        50% {
            font-size: 16px;
        }
        100% {
            font-size: 14px;
        }
    }

    .expire_date-tip {
        width: 100%;
        /*height: ;*/
        position: absolute;
        padding: 25px 0;
        text-align: center;
        color: #fff;
        font-size: 14px;
        animation: breathe 3s infinite;
    }

    .expire_date {
        color: red;
    }

    .award-title {
        text-align: center;
        -webkit-text-stroke: 1px #F0E68C;
    }

    .progress-container {
        width: 95%;
        display: flex;
        justify-content: space-between;
        margin: .1rem 2.5%;
        padding: .1rem;
        background-color: rgba(248, 248, 255, 0.4);
    }

    .left {
        flex: 7.5;
        /*background-color: #e0e0e0; !* 用于区分左侧内容 *!*/
    }

    .right {
        flex: 2.5;
        /*background-color: #c0c0c0; !* 用于区分右侧内容 *!*/
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
    }

    .progress-title {
        font-size: .2rem;
        color: #fff;
    }

    .receive-btn {
        background-color: #00c3f9 !important;
    }

    /* IE10 */
    progress {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    /* Firefox */
    progress::-moz-progress-bar {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    /* Chrome */
    progress::-webkit-progress-value {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    .progress-amount {
        font-size: .25rem;
        margin-top: .1rem;
        text-align: right;
        color: #FFD700;
    }

    .product-popup-content{
        /*width: 280px;*/
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    /*商品列表*/
    .product{
        width: 90px;
        height: 120px;
        display: flex;
        flex-direction: column;
        float: left;
        /*border: 1px solid red;*/
        margin: 3px;
        font-size: 14px;
        text-align: center;
        background-color: rgba(248, 248, 255, 0.4);
        border-radius: 5px;
        -webkit-box-shadow: 2px 2px 10px #000;
        box-shadow: 2px 2px 10px #000;
    }
    .goods-img{
        width: auto;
        flex: 7;
        background-color: #f4f4f4;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;

    }
    .product-info{
        flex: 3;
        background-color: #ccc;
        padding: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .product-price{
        padding: 5px 7px;
        color: #fff;
        background-color: #00c3f9;
        border-radius: 3px;
    }
</style>